module.exports = __webpack_public_path__ + "static/media/aircash-logo.e38b21d2.svg";